module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAATlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////+QlxstAAAAGXRSTlMAzGOcMr/J4pNBCOypxXkq2WhVHv2FhHIUEMOb3gAAAIpJREFUOMvt1LkOwjAQhOFJbPAZ5+Ka939RLCEoYkSmRcpXuPpl7TaLj+AjGteCRmbAViTR8F9Dh8aNIxqbcLRVZm8bTPV5fzBP3OHKazZBBgIlCzIlAwZKOpwoOWOixMF0EgNZ6CULHCVJ3voIj/A/Q/0AqGGhxCAmCi4rsDruShZVnL35yd8fwBM0kHcrGOC8mwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/winner/date.png
// module id = D6xy
// module chunks = 1